// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-text[data-v-c61fbd6e]{margin:auto;width:100%}@media screen and (min-width:25.6875rem){.dialog-text[data-v-c61fbd6e]{width:80%}}@media screen and (min-width:48.0625rem){.dialog-text[data-v-c61fbd6e]{width:50%}}.secondaryid-list[data-v-c61fbd6e]{margin:10px 0 30px 0}.snackbar[data-v-c61fbd6e]{margin-bottom:4.375rem}[data-v-c61fbd6e] .main-content{text-align:center}", ""]);
// Exports
module.exports = exports;
